(function () {
  const customStyles = `
    :host {
      position: fixed !important;
      top: 0 !important;
      bottom: 0 !important;
      left: 0 !important;
      right: 0 !important;
      width: 100% !important;
      height: 100% !important;
      pointer-events: none !important;
      background: transparent !important;
      background-color: transparent !important;
    }

    [data-shoplc-hide] {
      display: none !important; 
    }

    /* Container wrappers: completely transparent */
    [data-testid="uc-app-container"],
    [data-testid="uc-app-container"] > div,
    #app-focus-lock,
    #bottom-layer-focus-lock {
      background: transparent !important;
      background-color: transparent !important;
      pointer-events: none !important;
    }

    /* Hide backdrop overlay by default on the bottom banner */
    [data-testid="uc-overlay"],
    [data-testid="uc-backdrop"],
    div[class*="csvDjg"],
    div[class*="csvDjg"] > div:first-child,
    .sc-axZVg.csvDjg {
      display: none !important;
      background: transparent !important;
      background-color: transparent !important;
      opacity: 0 !important;
      visibility: hidden !important;
      pointer-events: none !important;
      width: 0 !important;
      height: 0 !important;
    }

    /* When Second Layer modal is open (.uc-modal-open), show dark transparent modal backdrop */
    :host(.uc-modal-open) [data-testid="uc-overlay"],
    :host(.uc-modal-open) [data-testid="uc-backdrop"],
    :host(.uc-modal-open) div[class*="csvDjg"],
    :host(.uc-modal-open) div[class*="csvDjg"] > div:first-child {
      display: block !important;
      background: rgba(0, 0, 0, 0.4) !important;
      background-color: rgba(0, 0, 0, 0.4) !important;
      opacity: 1 !important;
      visibility: visible !important;
      pointer-events: auto !important;
      width: 100% !important;
      height: 100% !important;
    }

    /* Second Layer Modal & Dialogs - keep interactive & natural height */
    [data-testid="uc-second-layer"],
    [data-testid="uc-modal"],
    [data-testid="uc-privacy-modal"],
    [role="dialog"],
    dialog {
      pointer-events: auto !important;
    }

    /* First Layer Pinned Bottom Banner */
    [data-testid="uc-default-banner"] {
      background: #ffffff !important;
      background-color: #ffffff !important;
      position: fixed !important;
      top: auto !important;
      bottom: 0 !important;
      left: 0 !important;
      right: 0 !important;
      width: 100% !important;
      max-width: 100vw !important;
      height: auto !important;
      min-height: 0 !important;
      border-radius: 0 !important;
      box-shadow: 0 -2px 16px rgba(0, 0, 0, 0.08) !important;
      border-top: 1px solid #e0e0e0 !important;
      border-left: none !important;
      border-right: none !important;
      border-bottom: none !important;
      margin: 0 !important;
      box-sizing: border-box !important;
      pointer-events: auto !important;
      overflow: visible !important;
      max-height: none !important;
      z-index: 2147483647 !important;
    }

    /* Remove scrollbars inside bottom banner only */
    [data-testid="uc-default-banner"] *,
    [data-testid="uc-default-banner"] [data-testid="uc-banner-content"],
    [data-testid="uc-default-banner"] [data-testid="uc-container"],
    [data-testid="uc-default-banner"] [data-testid="uc-container"] * {
      overflow: visible !important;
      max-height: none !important;
      scrollbar-width: none !important;
    }
    [data-testid="uc-default-banner"] *::-webkit-scrollbar {
      display: none !important;
      width: 0 !important;
      height: 0 !important;
    }

    /* Two-Column Grid Layout on Desktop (Banner only) */
    [data-testid="uc-default-banner"] [data-testid="uc-banner-content"] {
      background: #ffffff !important;
      background-color: #ffffff !important;
      display: grid !important;
      grid-template-columns: 1fr auto !important;
      grid-template-rows: auto auto !important;
      align-items: center !important;
      column-gap: 20px !important;
      row-gap: 4px !important;
      margin: 0 auto !important;
      width: 100% !important;
      padding-left: 20px !important;
      padding-right: 20px !important;
      box-sizing: border-box !important;
    }

    @media (min-width: 1200px) {
      [data-testid="uc-default-banner"] [data-testid="uc-message"] {
        white-space: nowrap !important;
      }
    }

    [data-testid="uc-default-banner"] [data-testid="uc-container"] * {
      padding-left: 0px !important;
      font-family: 'Nunito Sans' !important;
    }

    [data-testid="uc-default-banner"] [data-testid="uc-banner-content"] > div:not([data-testid="uc-container"]),
    [data-testid="uc-default-banner"] [data-testid="uc-footer"],
    [data-testid="uc-default-banner"] [data-testid="uc-footer"] > div {
      display: contents !important;
    }

    /* Left Top: Title, Subtitle, Message */
    [data-testid="uc-default-banner"] [data-testid="uc-container"] {
      grid-column: 1 !important;
      grid-row: 1 !important;
      max-width: 100% !important;
      text-align: left !important;
      display: flex !important;
      flex-direction: column !important;
      gap: 4px !important;
    }

    [data-testid="uc-default-banner"] [data-testid="uc-header"] > div,
    [data-testid="uc-default-banner"] [data-testid="uc-header"],
    [data-testid="uc-default-banner"] div[class*="gmeiOV"],
    [data-testid="uc-default-banner"] .sc-esYiGF {
      justify-content: flex-end !important;
    }

    [data-testid="uc-default-banner"] div[class*="brMwuP"] svg,
    [data-testid="uc-default-banner"] .sc-fXSGco svg,
    [data-testid="uc-default-banner"] [data-testid="uc-language-container"] svg,
    [data-testid="uc-default-banner"] div[class*="gmeiOV"] svg,
    [data-testid="uc-default-banner"] .sc-esYiGF svg,
    [data-testid="uc-default-banner"] [data-testid="uc-header"] svg,
    [data-testid="uc-default-banner"] [data-testid="uc-heading-title"] svg {
      width: 22px !important;
      height: 22px !important;
      min-width: 22px !important;
      min-height: 22px !important;
      max-width: 22px !important;
      max-height: 22px !important;
    }

    [data-testid="uc-default-banner"] [data-testid="uc-heading-title"] {
      font-size: 14px !important;
      font-weight: 700 !important;
      color: #111111 !important;
      display: flex !important;
      align-items: center !important;
      gap: 8px !important;
      margin: 0 0 2px 0 !important;
    }

    [data-testid="uc-default-banner"] [data-testid="uc-sub-heading"],
    [data-testid="uc-default-banner"] [data-testid="uc-heading-title"] + div {
      font-size: 13px !important;
      font-weight: 700 !important;
      text-transform: uppercase !important;
      color: #222222 !important;
      letter-spacing: 0.3px !important;
    }

    [data-testid="uc-default-banner"] [data-testid="uc-message"],
    [data-testid="uc-default-banner"] [data-testid="uc-container"] p {
      font-size: 12px !important;
      color: #333333 !important;
      line-height: 1.45 !important;
      margin: 0 !important;
      display: inline !important;
      visibility: visible !important;
      opacity: 1 !important;
    }

    [data-testid="uc-default-banner"] [data-testid="uc-show-more-link"],
    [data-testid="uc-default-banner"] a[data-testid="uc-show-more-link"],
    [data-testid="uc-default-banner"] .uc-more-info-link,
    [data-testid="uc-default-banner"] [data-testid="uc-container"] a {
      display: inline !important;
      visibility: visible !important;
      opacity: 1 !important;
      font-size: 12px !important;
      color: #333333 !important;
      text-decoration: underline !important;
      margin-left: 4px !important;
      cursor: pointer !important;
      pointer-events: auto !important;
    }

    /* Left Bottom: Links (Mehr lesen.., Impressum) & Powered by Usercentrics */
    [data-testid="uc-default-banner"] [data-testid="uc-footer"] > div > div:first-child,
    [data-testid="uc-default-banner"] div:has(> [data-testid="uc-anchors"]),
    [data-testid="uc-default-banner"] div:has(> [data-testid="uc-powered-by"]),
    [data-testid="uc-default-banner"] div[class*="bqLCKX"],
    [data-testid="uc-default-banner"] .sc-dLMFU {
      grid-column: 1 !important;
      grid-row: 2 !important;
      display: flex !important;
      flex-direction: column !important;
      align-items: flex-start !important;
      gap: 0px !important;
      padding: 0 !important;
      margin: 0 !important;
    }

    [data-testid="uc-default-banner"] [data-testid="uc-anchors"],
    [data-testid="uc-default-banner"] div[class*="jWqFlm"] > div:first-child,
    [data-testid="uc-default-banner"] div[class*="jWqFlm"],
    [data-testid="uc-default-banner"] div[class*="jwGFlm"],
    [data-testid="uc-default-banner"] .sc-fHjqPf,
    [data-testid="uc-default-banner"] .sc-jhjqPf,
    [data-testid="uc-default-banner"] div:has(> a[data-testid="uc-anchor-link"]),
    [data-testid="uc-default-banner"] div:has(> a[data-testid="uc-imprint-link"]) {
      padding: 0 !important;
      margin: 4px 0 2px 0 !important;
      display: flex !important;
      flex-direction: unset !important;
      align-items: center !important;
      flex-wrap: nowrap !important;
      gap: 16px !important;
    }

    [data-testid="uc-default-banner"] [data-testid="uc-anchors"] a,
    [data-testid="uc-default-banner"] [data-testid="uc-anchors"] button,
    [data-testid="uc-default-banner"] a[data-testid="uc-anchor-link"],
    [data-testid="uc-default-banner"] a[data-testid="uc-imprint-link"],
    [data-testid="uc-default-banner"] .uc-read-more-link {
      display: inline-flex !important;
      align-items: center !important;
      font-size: 12px !important;
      color: #444444 !important;
      text-decoration: underline !important;
      cursor: pointer !important;
      margin: 0 !important;
      padding: 0 !important;
      background: transparent !important;
      border: none !important;
    }

    [data-testid="uc-default-banner"] [data-testid="uc-anchors"] a:hover,
    [data-testid="uc-default-banner"] [data-testid="uc-anchors"] button:hover {
      color: #111111 !important;
    }

    /* Right-side action buttons (Banner only) */
    [data-testid="uc-default-banner"] [data-testid="uc-footer"] > div > div:last-child,
    [data-testid="uc-default-banner"] [data-testid="uc-buttons-container"],
    [data-testid="uc-default-banner"] div:has(> button[data-testid="uc-accept-all-button"]),
    [data-testid="uc-default-banner"] div[class*="hpUKQb"],
    [data-testid="uc-default-banner"] .sc-klVQts {
      grid-column: 2 !important;
      grid-row: 1 / span 2 !important;
      display: flex !important;
      flex-direction: row !important;
      align-items: center !important;
      justify-content: flex-end !important;
      gap: 16px !important;
      margin: 0 !important;
      padding: 0 12px !important;
      align-self: center !important;
      background: transparent !important;
      flex-shrink: 0 !important;
    }

    /* Button 1: Alles akzeptieren (Banner only) */
    [data-testid="uc-default-banner"] button[data-testid="uc-accept-all-button"] {
      order: 1 !important;
      background-color: #1a3db6 !important;
      color: #ffffff !important;
      border: 1px solid #1a3db6 !important;
      border-radius: 4px !important;
      font-size: 14px !important;
      font-weight: 500 !important;
      padding: 10px 20px !important;
      height: 42px !important;
      width: 175px !important;
      min-width: 175px !important;
      max-width: 175px !important;
      box-sizing: border-box !important;
      cursor: pointer !important;
      display: inline-flex !important;
      align-items: center !important;
      justify-content: center !important;
      white-space: nowrap !important;
      transition: background-color 0.2s ease !important;
    }

    [data-testid="uc-default-banner"] button[data-testid="uc-accept-all-button"]:hover {
      background-color: #143094 !important;
    }

    /* Button 2: Mehr (Banner only) */
    [data-testid="uc-default-banner"] button[data-testid="uc-more-button"],
    [data-testid="uc-default-banner"] button[data-testid="uc-customize-button"] {
      order: 2 !important;
      background-color: #ffffff !important;
      color: #111111 !important;
      border: 1px solid #4a4a4a !important;
      border-radius: 4px !important;
      font-size: 14px !important;
      font-weight: 600 !important;
      padding: 10px 20px !important;
      height: 42px !important;
      width: 175px !important;
      min-width: 175px !important;
      max-width: 175px !important;
      box-sizing: border-box !important;
      cursor: pointer !important;
      display: inline-flex !important;
      align-items: center !important;
      justify-content: center !important;
      white-space: nowrap !important;
      transition: all 0.2s ease !important;
    }

    [data-testid="uc-default-banner"] button[data-testid="uc-more-button"]:hover,
    [data-testid="uc-default-banner"] button[data-testid="uc-customize-button"]:hover {
      background-color: #f7f7f7 !important;
      border-color: #111111 !important;
    }

    /* Link 3: Datenschutzerklärung (Banner only) */
    [data-testid="uc-default-banner"] [data-testid="uc-privacy-policy-link"],
    [data-testid="uc-default-banner"] [data-testid="uc-buttons-container"] a[data-testid="uc-privacy-policy-link"],
    [data-testid="uc-default-banner"] [data-testid="uc-buttons-container"] a.uc-privacy-link,
    [data-testid="uc-default-banner"] a.uc-privacy-link,
    [data-testid="uc-default-banner"] div[class*="hpUKQb"] a.uc-privacy-link {
      order: 3 !important;
      color: #1a3db6 !important;
      font-size: 14px !important;
      font-weight: 400 !important;
      text-decoration: none !important;
      margin-left: 4px !important;
      white-space: nowrap !important;
      display: inline-flex !important;
      align-items: center !important;
      cursor: pointer !important;
    }

    [data-testid="uc-default-banner"] [data-testid="uc-privacy-policy-link"]:hover,
    [data-testid="uc-default-banner"] a.uc-privacy-link:hover {
      text-decoration: underline !important;
    }

    /* Powered by Usercentrics tag */
    [data-testid="uc-default-banner"] [data-testid="uc-powered-by"] {
      font-size: 11px !important;
      color: #888888 !important;
      margin-top: 2px !important;
    }

    /* Privacy button trigger */
    [data-testid="uc-privacy-button"] {
      pointer-events: auto !important;
    }

    /* Mobile responsiveness for banner */
    @media (max-width: 991px) {

      [data-testid="uc-default-banner"] [data-testid="uc-banner-content"] {
        display: flex !important;
        flex-direction: column !important;
        align-items: stretch !important;
        gap: 6px !important;
        max-width: 100% !important;
        width: 100% !important;
        padding: 14px 16px 10px 16px !important;
      }

      [data-testid="uc-default-banner"] [data-testid="uc-header"] > div,
      [data-testid="uc-default-banner"] [data-testid="uc-header"],
      [data-testid="uc-default-banner"] div[class*="gmeiOV"],
      [data-testid="uc-default-banner"] .sc-esYiGF {
        gap: 0 !important;
      }

      [data-testid="uc-default-banner"] [data-testid="uc-header-wrapper"],
      [data-testid="uc-default-banner"] div[class*="gnlcrN"],
      [data-testid="uc-default-banner"] div[class*="kdBSHD"],
      [data-testid="uc-default-banner"] .sc-kdBSHD {
        padding-bottom: 0 !important;
      }

      [data-testid="uc-default-banner"] [data-testid="uc-container"] {
        order: 1 !important;
        grid-column: auto !important;
        grid-row: auto !important;
        display: flex !important;
        flex-direction: column !important;
        gap: 4px !important;
        max-width: 100% !important;
        width: 100% !important;
        text-align: left !important;
      }

      [data-testid="uc-default-banner"] [data-testid="uc-heading-title"] {
        font-size: 14px !important;
        font-weight: 700 !important;
      }

      [data-testid="uc-default-banner"] [data-testid="uc-sub-heading"] {
        font-size: 13px !important;
        font-weight: 700 !important;
        margin-bottom: 2px !important;
      }

      [data-testid="uc-default-banner"] [data-testid="uc-message"],
      [data-testid="uc-default-banner"] [data-testid="uc-container"] p,
      [data-testid="uc-default-banner"] .uc-more-info-link,
      [data-testid="uc-default-banner"] [data-testid="uc-show-more-link"] {
        font-size: 12px !important;
        line-height: 1.45 !important;
        margin: 0 !important;
      }

      /* Reset all layout wrappers to full width flex columns */
      [data-testid="uc-default-banner"] [data-testid="uc-banner-content"] > div:not([data-testid="uc-container"]),
      [data-testid="uc-default-banner"] [data-testid="uc-footer"],
      [data-testid="uc-default-banner"] [data-testid="uc-footer"] > div,
      [data-testid="uc-default-banner"] [data-testid="uc-footer"] > div > div,
      [data-testid="uc-default-banner"] div[class*="bqLCKX"],
      [data-testid="uc-default-banner"] .sc-dLMFU {
        order: 2 !important;
        grid-column: auto !important;
        grid-row: auto !important;
        display: flex !important;
        flex-direction: column !important;
        align-items: stretch !important;
        width: 100% !important;
        max-width: 100% !important;
        margin: 0 !important;
        padding: 0 !important;
      }

      /* 1. Anchors row (Mehr lesen... Impressum) positioned above buttons */
      [data-testid="uc-default-banner"] [data-testid="uc-anchors"],
      [data-testid="uc-default-banner"] div[class*="jwGFlm"],
      [data-testid="uc-default-banner"] div[class*="jWqFlm"],
      [data-testid="uc-default-banner"] .sc-fHjqPf,
      [data-testid="uc-default-banner"] .sc-jhjqPf {
        order: 1 !important;
        display: flex !important;
        flex-direction: row !important;
        align-items: center !important;
        justify-content: flex-start !important;
        flex-wrap: nowrap !important;
        gap: 16px !important;
        margin: 4px 0 8px 0 !important;
        padding: 0 !important;
        width: 100% !important;
      }

      /* 2. Buttons container and its intermediate wrappers - full width column */
      [data-testid="uc-default-banner"] [data-testid="uc-footer"] > div > div:last-child,
      [data-testid="uc-default-banner"] [data-testid="uc-buttons-container"],
      [data-testid="uc-default-banner"] div[class*="hpUKQb"],
      [data-testid="uc-default-banner"] .sc-klVQts,
      [data-testid="uc-default-banner"] div[class*="hfvcUB"],
      [data-testid="uc-default-banner"] .sc-koXPp,
      [data-testid="uc-default-banner"] div[class*="erNbfm"],
      [data-testid="uc-default-banner"] div[class*="bmzYK"],
      [data-testid="uc-default-banner"] [data-testid="first-line-buttons"],
      [data-testid="uc-default-banner"] div:has(> button[data-testid="uc-accept-all-button"]) {
        order: 2 !important;
        grid-column: auto !important;
        grid-row: auto !important;
        display: flex !important;
        flex-direction: column !important;
        align-items: stretch !important;
        justify-content: flex-start !important;
        width: 100% !important;
        min-width: 100% !important;
        max-width: 100% !important;
        gap: 8px !important;
        padding: 0 !important;
        margin: 0 !important;
      }

      /* 3. Datenschutzerklärung: strictly left-aligned link above the action buttons */
      [data-testid="uc-default-banner"] [data-testid="uc-privacy-policy-link"],
      [data-testid="uc-default-banner"] [data-testid="uc-buttons-container"] a[data-testid="uc-privacy-policy-link"],
      [data-testid="uc-default-banner"] [data-testid="uc-buttons-container"] a.uc-privacy-link,
      [data-testid="uc-default-banner"] a.uc-privacy-link,
      [data-testid="uc-default-banner"] div[class*="hpUKQb"] a.uc-privacy-link {
        order: 1 !important;
        display: block !important;
        text-align: left !important;
        align-self: flex-start !important;
        justify-content: flex-start !important;
        font-size: 13px !important;
        color: #1a3db6 !important;
        text-decoration: none !important;
        margin: 0 0 2px 0 !important;
        padding: 0 !important;
        width: 100% !important;
      }

      /* 4. Alles akzeptieren button - full width column button */
      [data-testid="uc-default-banner"] button[data-testid="uc-accept-all-button"],
      [data-testid="uc-default-banner"] button[class*="hnTZBn"] {
        order: 2 !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        width: 100% !important;
        min-width: 100% !important;
        max-width: 100% !important;
        height: 44px !important;
        border-radius: 4px !important;
        font-size: 14px !important;
        font-weight: 500 !important;
        padding: 10px 20px !important;
        background-color: #1a3db6 !important;
        color: #ffffff !important;
        border: 1px solid #1a3db6 !important;
        box-sizing: border-box !important;
        margin: 0 !important;
      }

      /* 5. Mehr button - full width column button */
      [data-testid="uc-default-banner"] button[data-testid="uc-more-button"],
      [data-testid="uc-default-banner"] button[data-testid="uc-customize-button"],
      [data-testid="uc-default-banner"] button[class*="hjnymd"] {
        order: 3 !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        width: 100% !important;
        min-width: 100% !important;
        max-width: 100% !important;
        height: 44px !important;
        border-radius: 4px !important;
        font-size: 14px !important;
        font-weight: 500 !important;
        padding: 10px 20px !important;
        background-color: #ffffff !important;
        color: #111111 !important;
        border: 1px solid #111111 !important;
        box-sizing: border-box !important;
        margin: 0 !important;
      }

      /* 6. Powered by Usercentrics tag: centered at the very bottom */
      [data-testid="uc-default-banner"] [data-testid="uc-powered-by"],
      [data-testid="uc-default-banner"] div[class*="klVQfs"],
      [data-testid="uc-default-banner"] .sc-klVQfs,
      [data-testid="uc-default-banner"] div:has(> a[href*="usercentrics.com"]) {
        order: 10 !important;
        display: flex !important;
        justify-content: center !important;
        align-items: center !important;
        text-align: center !important;
        width: 100% !important;
        max-width: 100% !important;
        padding: 0 !important;
        margin: 10px 0 2px 0 !important;
        font-size: 11px !important;
        color: #666666 !important;
      }

      [data-testid="uc-default-banner"] div[class*="klVQfs"] *,
      [data-testid="uc-default-banner"] .sc-klVQfs *,
      [data-testid="uc-default-banner"] [data-testid="uc-powered-by"] *,
      [data-testid="uc-default-banner"] a[href*="usercentrics.com"],
      [data-testid="uc-default-banner"] .sc-iHbSHJ {
        text-align: center !important;
        margin-left: auto !important;
        margin-right: auto !important;
        display: block !important;
        width: auto !important;
        padding-top: 4px;
      }

      [data-testid="uc-default-banner"] [data-testid="uc-banner-content"] > div:not([data-testid="uc-container"]) {
        padding-left: 0px !important;
      }
    }
  `;

  let shadowObserver = null;
  let isMutating = false;

  function injectUsercentricsCSS() {
    const ucRoot = document.getElementById('usercentrics-root');
    if (ucRoot) {
      ucRoot.style.setProperty('position', 'fixed', 'important');
      ucRoot.style.setProperty('top', '0', 'important');
      ucRoot.style.setProperty('bottom', '0', 'important');
      ucRoot.style.setProperty('left', '0', 'important');
      ucRoot.style.setProperty('right', '0', 'important');
      ucRoot.style.setProperty('width', '100%', 'important');
      ucRoot.style.setProperty('height', '100%', 'important');
      ucRoot.style.setProperty('background', 'transparent', 'important');
      ucRoot.style.setProperty('pointer-events', 'none', 'important');
      ucRoot.style.setProperty('z-index', '2147483647', 'important');

      if (ucRoot.shadowRoot) {
        if (!shadowObserver) {
          shadowObserver = new MutationObserver(function () {
            if (!isMutating) {
              injectUsercentricsCSS();
            }
          });
          shadowObserver.observe(ucRoot.shadowRoot, { childList: true, subtree: true, attributes: true });
        }

        isMutating = true;
        try {
          // Check if second layer modal is open
          const secondLayer = ucRoot.shadowRoot.querySelector('[data-testid="uc-second-layer"], [data-testid="uc-modal"], [role="dialog"]');
          
          if (secondLayer) {
            ucRoot.classList.add('uc-modal-open');
            if (ucRoot.shadowRoot.host) {
              ucRoot.shadowRoot.host.classList.add('uc-modal-open');
            }
          } else {
            ucRoot.classList.remove('uc-modal-open');
            if (ucRoot.shadowRoot.host) {
              ucRoot.shadowRoot.host.classList.remove('uc-modal-open');
            }
          }

          // Manage backdrop overlay (hide on bottom banner, allow semi-transparent on modal)
          const backdropElements = ucRoot.shadowRoot.querySelectorAll('[data-testid="uc-overlay"], [data-testid="uc-backdrop"], div[class*="csvDjg"]');
          backdropElements.forEach(el => {
            if (secondLayer) {
              el.style.setProperty('display', 'block', 'important');
              el.style.setProperty('background', 'rgba(0, 0, 0, 0.4)', 'important');
              el.style.setProperty('background-color', 'rgba(0, 0, 0, 0.4)', 'important');
              el.style.setProperty('pointer-events', 'auto', 'important');
              el.style.setProperty('opacity', '1', 'important');
              el.style.setProperty('visibility', 'visible', 'important');
            } else {
              el.style.setProperty('display', 'none', 'important');
              el.style.setProperty('pointer-events', 'none', 'important');
              el.style.setProperty('background', 'transparent', 'important');
              el.style.setProperty('background-color', 'transparent', 'important');
              el.style.setProperty('opacity', '0', 'important');
              el.style.setProperty('visibility', 'hidden', 'important');
            }
          });

          // Ensure app container is transparent
          const appContainer = ucRoot.shadowRoot.querySelector('[data-testid="uc-app-container"]');
          if (appContainer) {
            appContainer.style.setProperty('background', 'transparent', 'important');
            appContainer.style.setProperty('background-color', 'transparent', 'important');
            if (appContainer.firstElementChild) {
              appContainer.firstElementChild.style.setProperty('background', 'transparent', 'important');
              appContainer.firstElementChild.style.setProperty('background-color', 'transparent', 'important');
            }
          }

          const banner = ucRoot.shadowRoot.querySelector('[data-testid="uc-default-banner"]');
          if (banner) {
            banner.style.setProperty('position', 'fixed', 'important');
            banner.style.setProperty('top', 'auto', 'important');
            banner.style.setProperty('bottom', '0', 'important');
            banner.style.setProperty('left', '0', 'important');
            banner.style.setProperty('right', '0', 'important');
            banner.style.setProperty('width', '100%', 'important');
            banner.style.setProperty('height', 'auto', 'important');
            banner.style.setProperty('min-height', '0', 'important');
            banner.style.setProperty('background', '#ffffff', 'important');
            banner.style.setProperty('background-color', '#ffffff', 'important');

            // 1. Ensure "Mehr erfahren" is inline at the end of the message text inside the banner
            let messageEl = banner.querySelector('[data-testid="uc-message"]') || 
                            banner.querySelector('[data-testid="uc-container"] p');
            
            if (!messageEl) {
              const allBannerElements = Array.from(banner.querySelectorAll('p, div, span'));
              messageEl = allBannerElements.find(el => {
                const text = (el.textContent || '').trim();
                return text.includes('Diese Website verwendet Cookies') && !el.querySelector('p, div');
              });
            }

            if (messageEl) {
              let showMoreLink = banner.querySelector('.uc-more-info-link');
              if (!showMoreLink) {
                const bannerLinks = Array.from(banner.querySelectorAll('a, button'));
                showMoreLink = bannerLinks.find(el => {
                  const txt = (el.textContent || '').trim().toLowerCase();
                  return (txt.includes('mehr erfahren') || txt.includes('learn more')) && !el.classList.contains('uc-privacy-link');
                });
              }
              
              if (!showMoreLink) {
                showMoreLink = document.createElement('a');
                showMoreLink.className = 'uc-more-info-link';
                showMoreLink.setAttribute('data-testid', 'uc-show-more-link');
                showMoreLink.href = 'https://www.shoplc.de/privacy-policy.html';
                showMoreLink.textContent = 'Mehr erfahren';
                showMoreLink.target = '_blank';
              }
              
              showMoreLink.classList.add('uc-more-info-link');
              showMoreLink.style.setProperty('display', 'inline', 'important');
              showMoreLink.style.setProperty('visibility', 'visible', 'important');
              showMoreLink.style.setProperty('opacity', '1', 'important');
              showMoreLink.style.setProperty('cursor', 'pointer', 'important');
              showMoreLink.style.setProperty('pointer-events', 'auto', 'important');
              
              if (showMoreLink.parentElement !== messageEl) {
                messageEl.appendChild(document.createTextNode(' '));
                messageEl.appendChild(showMoreLink);
              }
            }

            // 2. Move / Ensure "Datenschutzerklärung" is inside banner buttons container AFTER the "Mehr" button
            const acceptBtn = banner.querySelector('button[data-testid="uc-accept-all-button"]') ||
                              banner.querySelector('button[class*="hnTZBn"]');
            const buttonsContainer = banner.querySelector('[data-testid="uc-buttons-container"], [data-testid="first-line-buttons"], div[class*="hfvcUB"], div[class*="hpUKQb"], div[class*="erNbfm"], div[class*="bmzYK"]') || 
                                    acceptBtn?.parentElement;
            
            if (buttonsContainer) {
              let privacyLink = banner.querySelector('.uc-privacy-link');
              if (!privacyLink) {
                const bannerLinks = Array.from(banner.querySelectorAll('a'));
                privacyLink = bannerLinks.find(a => {
                  const txt = (a.textContent || '').trim().toLowerCase();
                  return (txt === 'datenschutzerklärung' || txt === 'datenschutz') && !a.classList.contains('uc-more-info-link');
                });
              }

              if (!privacyLink) {
                privacyLink = document.createElement('a');
                privacyLink.className = 'uc-privacy-link';
                privacyLink.setAttribute('data-testid', 'uc-privacy-policy-link');
                privacyLink.href = 'https://www.shoplc.de/privacy-policy.html';
                privacyLink.textContent = 'Datenschutzerklärung';
                privacyLink.target = '_blank';
              }

              privacyLink.classList.add('uc-privacy-link');
              privacyLink.style.setProperty('visibility', 'visible', 'important');
              privacyLink.style.setProperty('opacity', '1', 'important');
              privacyLink.style.setProperty('pointer-events', 'auto', 'important');
              privacyLink.style.setProperty('cursor', 'pointer', 'important');
              if (privacyLink.parentElement !== buttonsContainer) {
                buttonsContainer.appendChild(privacyLink);
              }
            }

            // 3. Ensure "Mehr lesen.." and "Impressum" are in the same row inside banner anchorsContainer
            const anchorsContainer = banner.querySelector('[data-testid="uc-anchors"]') || banner.querySelector('div[class*="bqLCKX"] > div:first-child');
            if (anchorsContainer) {
              const allLinksAndButtons = Array.from(banner.querySelectorAll('a, button'));
              
              // Find "Mehr lesen" element
              let readMoreEl = allLinksAndButtons.find(el => {
                const txt = (el.textContent || '').trim().toLowerCase();
                return (txt.includes('mehr lesen') || txt.includes('read more')) && !el.classList.contains('uc-privacy-link') && !el.classList.contains('uc-more-info-link');
              });

              // Find "Impressum" element
              let imprintEl = banner.querySelector('a[data-testid="uc-imprint-link"]') || allLinksAndButtons.find(el => {
                const txt = (el.textContent || '').trim().toLowerCase();
                return (txt === 'impressum' || txt === 'imprint') && !el.classList.contains('uc-privacy-link') && !el.classList.contains('uc-more-info-link');
              });

              if (readMoreEl && readMoreEl.parentElement !== anchorsContainer) {
                readMoreEl.classList.add('uc-read-more-link');
                anchorsContainer.insertBefore(readMoreEl, anchorsContainer.firstChild);
              }

              if (imprintEl && imprintEl.parentElement !== anchorsContainer) {
                anchorsContainer.appendChild(imprintEl);
              }
            }
          }

          let styleEl = ucRoot.shadowRoot.getElementById('shoplc-uc-custom-css');
          if (!styleEl) {
            styleEl = document.createElement('style');
            styleEl.id = 'shoplc-uc-custom-css';
            ucRoot.shadowRoot.appendChild(styleEl);
          }
          if (styleEl.textContent !== customStyles) {
            styleEl.textContent = customStyles;
          }
        } finally {
          setTimeout(function () {
            isMutating = false;
          }, 30);
        }
      }
    }
  }

  // Run injection across all lifecycle stages
  injectUsercentricsCSS();
  window.addEventListener('UC_UI_INITIALIZED', injectUsercentricsCSS);
  window.addEventListener('DOMContentLoaded', injectUsercentricsCSS);
  window.addEventListener('load', injectUsercentricsCSS);

  // Polling interval to guarantee links stay present even after asynchronous Usercentrics hydration
  let pollCount = 0;
  const pollInterval = setInterval(function () {
    injectUsercentricsCSS();
    pollCount++;
    if (pollCount > 40) {
      clearInterval(pollInterval);
    }
  }, 150);

  const observer = new MutationObserver(function () {
    injectUsercentricsCSS();
  });

  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      observer.observe(document.body, { childList: true, subtree: true });
    });
  }
})();
